import styled, { css } from 'styled-components';
import { LanguagePairBreadcrumbs as LanguagePairBreadcrumbsComponent } from 'src/containers';

export const LanguagePairBreadcrumbs = styled(LanguagePairBreadcrumbsComponent)(
  ({ theme }) => css`
    padding-top: ${theme.sz.s4};
    margin-top: 0;
    @media (min-width: ${theme.sz.md}) {
      padding-top: ${theme.sz.s8};
    }
  `,
);

export const Wrapper = styled.div(
  ({ theme }) => css`
    height: auto;
    color: ${theme.co.neutral99};
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xl};
    padding-bottom: ${theme.sz.s2};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.heading.desktop.m};
      padding-bottom: 0;
    }
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
    padding-bottom: ${theme.sz.s12};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.m};
      padding-bottom: ${theme.sz.s6};
    }
  `,
);

export const Flag = styled.img(
  ({ theme }) => css`
    height: ${theme.sz.s24};
    width: ${theme.sz.s24};
    margin-right: ${theme.sz.s6};

    @media (max-width: ${theme.sz.md}) {
      height: ${theme.sz.s12};
      width: ${theme.sz.s12};
      margin-right: ${theme.sz.s2};
    }
  `,
);

export const FlexWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    max-width: ${theme.sz.md};
    margin: auto;
    @media (max-width: ${theme.sz.md}) {
      padding: 0 ${theme.sz.s6};
    }
  `,
);

export const MobileFlexWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    padding-bottom: ${theme.sz.s2};
  `,
);
